import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import WelcomeStep from './components/steps/WelcomeStep';
import LearningGoalStep from './components/steps/LearningGoalStep';
import MotivationStep from './components/steps/MotivationStep';
import ExperienceLevelStep from './components/steps/ExperienceLevelStep';
import UsageStyleStep from './components/steps/UsageStyleStep';
import CollaborationStep from './components/steps/CollaborationStep';
import Subscription from './components/steps/Subscription';
import ProgressBar from './components/ProgressBar';

const STEPS = [
  { component: WelcomeStep, showProgress: false },
  { component: LearningGoalStep, showProgress: true },
  { component: MotivationStep, showProgress: true },
  { component: ExperienceLevelStep, showProgress: true },
  { component: UsageStyleStep, showProgress: true },
  { component: CollaborationStep, showProgress: true },
  { component: Subscription, showProgress: true },
];

const OnboardingFlow = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [formData, setFormData] = useState({
    learningGoal: '',
    motivation: '',
    experienceLevel: '',
    usageStyle: '',
    collaborators: [],
    selectedPlan: 'free',
  });

  const handleNext = (stepData = {}) => {
    setFormData((prev) => ({ ...prev, ...stepData }));
    if (currentStep < STEPS.length - 1) {
      setCurrentStep(currentStep + 1);
    }
  };

  const handleBack = () => {
    if (currentStep > 0) {
      setCurrentStep(currentStep - 1);
    }
  };

  const getCurrentStep = () => {
    const StepComponent = STEPS[currentStep].component;
    return <StepComponent onNext={handleNext} onBack={handleBack} formData={formData} canGoBack={currentStep > 0} />;
  };

  const showProgress = STEPS[currentStep].showProgress;
  const progressPercentage = showProgress ? ((currentStep - 1) / (STEPS.length - 2)) * 100 : 0;

  return (
    <div className="h-full bg-background flex flex-col overflow-auto">
      {showProgress && (
        <div className="w-full">
          <ProgressBar progress={progressPercentage} />
        </div>
      )}

      <div className="flex-1 flex items-center justify-center p-4">
        <div className="w-full max-w-4xl">
          <AnimatePresence mode="wait">
            <motion.div
              key={currentStep}
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              exit={{ opacity: 0, x: -50 }}
              transition={{ duration: 0.3 }}
              className="w-full">
              {getCurrentStep()}
            </motion.div>
          </AnimatePresence>
        </div>
      </div>
    </div>
  );
};

export default OnboardingFlow;
